import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { forwardRef } from 'react';
const ListboxItem = forwardRef(({ children, className, ...rest }, ref) => {
    return (_jsx("li", { ...rest, className: buildClassName('box-border flex h-14 w-full items-center px-4 py-[7px]', 'first:rounded-t-lg last:rounded-b-lg', 'focus:bg-primary-blue/10 focus-visible:bg-primary-blue/10', 'focus:outline-none focus-visible:outline-none', 'hover:bg-primary-blue/10', 'skyline-text-body-1 leading-5.5 text-black', className), ref: ref, children: children }));
});
export default ListboxItem;
//# sourceMappingURL=ListboxItem.js.map